<template>
  <!-- 에러 페이지 -->
<!--  <div class="container">-->
<!--  <img-->
<!--      src="@/assets/imgs/404page.jpg"-->
<!--      alt="Page Not Found"-->
<!--      width="50%"-->
<!--      align="center"-->
<!--    />-->
<!--  </div>-->
  <div class="error-wrap">
    <img src="@/assets/imgs/img_question-mark@2x.png" alt="404에러메세지">
    <p class="error-tit">잠깐! 이 주소가 맞나요?</p>
    <p class="error-text">요청하신 페이지의 주소가 변경, 삭제되었거나 잘못된 주소를 입력하셨네요!<br>
      궁금한 점이 있으시면 언제든 고객센터<span>(1661-3773)</span>를 통해 문의해 주시기 바랍니다.</p>
    <button @click="goHome()">홈으로 돌아가기</button>
  </div>
</template>

<script>
export default {
  /*mounted() {
    // 에러 페이지 표출 시 3초 후 홈으로 가도록 함.
    const that = this;
    setTimeout(function () {
      that.$router.push({ name: "Home" });
    }, 3000);
  },*/
  methods: {
    goHome(){
      if (this.$router.currentRoute.name != "Home") {
        this.$router.push({ name: "Home" });
      }
    }
  },
};
</script>

<style scoped>
.container {
  text-align: center;
}
#wrap {
  padding: 10px;
  text-align: center;
}
.img {
  margin-bottom: 10px;
}
.txt {
  margin-bottom: 10px;
  font-size: 14px;
  line-height: 1.57;
  letter-spacing: -0.5px;
  text-align: center;
  color: #898989;
}
.tel {
  margin-bottom: 40px;
}
.btn1-wrap {
  margin-bottom: 10px;
}
.btn2-wrap {
  margin-bottom: 100px;
}
.btn1 {
  width: 330px;
  height: 60px;
  font-size: 17px;
  font-weight: bold;
  line-height: 60px;
  letter-spacing: -0.5px;
  text-align: center;
  color: #ffffff;
  background-color: #1a7cff;
}
.btn2 {
  width: 330px;
  height: 60px;
  font-size: 17px;
  line-height: 60px;
  letter-spacing: -0.5px;
  text-align: center;
  color: #898989;
  background-color: #ffffff;
  border: solid 1px #dddddd;
}
.btn-download-support {
  background-color: #eee;
  padding: 3px 10px;
}
a {
  display: inline-block;
  text-decoration: none;
  color: #898989;
}
.copy {
  font-size: 12px;
  line-height: 1.42;
  color: #898989;
}

@media all and (min-width: 1024px){
  .error-wrap{
    padding: 150px 0;
    text-align: center;
  }
  .error-wrap img{
    width: 400px;
    margin-bottom: 40px;
  }
  .error-wrap p.error-tit{
    margin-bottom: 20px;
    font-family: 'Nexon';
    letter-spacing: -1.2px;
    text-align: center;
    font-size: 40px;
    color: #1fcaff;
  }
  .error-wrap p.error-text{
    margin-bottom: 30px;
    font-family: "PretendardMedium";
    letter-spacing: -0.36px;
    font-size: 18px;
    color: #333;
  }
  .error-wrap p.error-text span{
    color: #1fcaff;
  }
  .error-wrap button{
    display: inline-block;
    border: solid 2px #3e3e3e;
    padding: 5px 30px;
    border-radius: 30px;
    font-family: "PretendardMedium";
    text-decoration: none;
    letter-spacing: -1.2px;
    font-weight: 300;
    font-size: 20px;
    color: #3e3e3e;
    transition: all 0.3s;
  }
  .error-wrap button:hover{
    border: solid 2px #1fcaff;
    color: #1fcaff;
    transition: all 0.3s;
  }
}

@media all and (min-width: 768px) and (max-width: 1023px){
  .error-wrap{
    padding: 150px 0;
    text-align: center;
  }
  .error-wrap img{
    width: 400px;
    margin-bottom: 40px;
  }
  .error-wrap p.error-tit{
    margin-bottom: 20px;
    font-family: 'Nexon';
    letter-spacing: -1.2px;
    text-align: center;
    font-size: 40px;
    color: #1fcaff;
  }
  .error-wrap p.error-text{
    margin-bottom: 30px;
    font-family: "PretendardMedium";
    letter-spacing: -0.36px;
    font-size: 18px;
    color: #333;
  }
  .error-wrap p.error-text span{
    color: #1fcaff;
  }
  .error-wrap button{
    display: inline-block;
    border: solid 2px #3e3e3e;
    padding: 5px 30px;
    border-radius: 30px;
    font-family: "PretendardMedium";
    text-decoration: none;
    letter-spacing: -1.2px;
    font-weight: 300;
    font-size: 20px;
    color: #3e3e3e;
    transition: all 0.3s;
  }
  .error-wrap button:hover{
    border: solid 2px #1fcaff;
    color: #1fcaff;
    transition: all 0.3s;
  }
}

@media all and (max-width: 767px){
  .error-wrap{
    padding: 100px 50px;
    text-align: center;
  }
  .error-wrap img{
    width: 280px;
    margin-bottom: 40px;
  }
  .error-wrap p.error-tit{
    margin-bottom: 10px;
    font-family: 'Nexon';
    letter-spacing: -1.2px;
    text-align: center;
    font-size: 25px;
    color: #1fcaff;
  }
  .error-wrap p.error-text{
    margin-bottom: 20px;
    font-family: "PretendardMedium";
    text-align: center;
    letter-spacing: -0.36px;
    font-size: 16px;
    color: #333;
  }
  .error-wrap p.error-text br{
    display: none;
  }
  .error-wrap p.error-text span{
    color: #1fcaff;
  }
  .error-wrap button{
    display: inline-block;
    height: 45px;
    border: solid 2px #3e3e3e;
    padding: 5px 30px;
    border-radius: 30px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    font-family: "PretendardMedium";
    text-decoration: none;
    vertical-align: middle;
    line-height: 1;
    letter-spacing: -1.2px;
    font-weight: 300;
    font-size: 16px;
    color: #3e3e3e;
    transition: all 0.3s;
  }
}


</style>